import { render, staticRenderFns } from "./ManagerMenu.vue?vue&type=template&id=27f60c80&"
import script from "./ManagerMenu.vue?vue&type=script&lang=js&"
export * from "./ManagerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports